export const TOAST_DURATION_IN_MS = 7000;

export const TOAST_PERSISTENT_DURATION_IN_MS = Number.POSITIVE_INFINITY;

export const TOAST_CLASS_NAME = 'toolkit-react-hot-toast';

export const COMPARABLES_ALERTS_TOAST_CLASS_NAME = 'comparables-alerts-toast';

export const COMPARABLES_TOAST_TOP_CSS_VAR = '--comparables-toast-top';

export const COMPARABLES_TOAST_RIGHT_CSS_VAR = '--comparables-toast-right';
